import { ViewModel,View, ViewModelMessage } from "binder"
import { DragDropPossibilityChecker, DropAppliedViewModelMessage } from "uicomponents";
import { FormBuilderComponent } from "../../components";
import { ChildAcceptableFormBuilderElement, ElementDecorator, FormBuilderElement } from "../../element";
import { DragableElementDecoratorView } from "../dragableElementDecorator/dragableElementDecorator-view";
import { DragableElementDecoratorViewModel } from "../dragableElementDecorator/dragableElementDecorator-viewModel";
import { CompactView } from "./compact-view";
import  { ComponentDropDecoratorView } from "./componentDropDecorator-view"
import { customDeserializer, customSerializer } from "src/formBuilder/serialization/customSerializer";

export class ComponentDropDecoratorViewModel extends ElementDecorator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ComponentDropDecoratorView();
    }
    public getTypeId(): string {
        return "VM-228638C0-405C-4343-B10B-C7602A2B32DC"
    }

    override handleMessage(message:ViewModelMessage){
        if(message instanceof DragDropPossibilityChecker){
            if(message.dragged instanceof FormBuilderComponent){
                return message.createAllowanceResponse("Allowed");
            }else if(message.dragged instanceof DragableElementDecoratorViewModel){
                return message.createAllowanceResponse("Allowed");
            }else{
                return super.handleMessage(message);
            }
        }else if(message instanceof DropAppliedViewModelMessage && message.dragged instanceof FormBuilderComponent){
            let childAcceptableThis  = (<ChildAcceptableFormBuilderElement><any>this);
            if(childAcceptableThis.component.canAcceptMultipleContent==false && childAcceptableThis.children.length!=0){
                this.messageBoxWarningYesNo('Do you want to remove the element?','delete')
                .then(x=>{
                    if(x=='yes'){
                        let element = (<any>message.dragged).Create(this.self);
                        childAcceptableThis.addChild(element,message.mouseEvent);
                    }
                });
            }else{
                let element = message.dragged.Create(this.self);
                childAcceptableThis.addChild(element,message.mouseEvent);
            }
            return null;
        }else if(message instanceof DropAppliedViewModelMessage && message.dragged instanceof DragableElementDecoratorViewModel){
            let childAcceptableThis  = (<ChildAcceptableFormBuilderElement><any>this);
            if(childAcceptableThis.component.canAcceptMultipleContent==false && childAcceptableThis.children.length!=0){
                this.messageBoxWarningYesNo('do you want to remove the element?','delete')
                .then(x=>{
                    if(x=='yes'){
                        let element = (<any>message.dragged).self;
                        let json = new customSerializer().serialize(element.self);
                        new customDeserializer().deserialize(this,json,this.self.DataContext);
                        if(message.shiftKey==false){
                            element.self.removeElementFromParent();
                        }
                    }
                });
            }else{
                let element = message.dragged.self;
                let json = new customSerializer().serialize(element.self);
                new customDeserializer().deserialize(this,json,this.self.DataContext);
                if(message.shiftKey==false){
                    element.self.removeElementFromParent();
                }
            }
            return null;
        }else{
            return super.handleMessage(message);
        }
    }

    getCompactViewForFormBuilderStructureViewDecorators(vm){
        return new CompactView();
    }

}
